import React, { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import Grid from "@material-ui/core/Grid";
import { toast } from "react-toastify";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import Typography from "@material-ui/core/Typography";
import { Link, withRouter, useHistory } from "react-router-dom";
import "./style.scss";

import { auth } from "../Firebase";
import { addUser } from "../../store/actions/action";
import userService from "../../services/userService";
import NewNavbar from '../../new-components/NewNavbar'
import NewPageHeader from "../../new-components/NewPageHeader";
import NewOverrides from '../../new-components/NewOverrides'
import NewDesignSystem from '../../new-components/NewDesignSystem'
import NewBackButton from '../../new-components/NewBackButton'
import NewFooter from '../../new-components/NewFooter'
import NewMadeWith from '../../new-components/NewMadeWith'
import NewScrollTop from '../../new-components/NewScrollTop'

const SignUpPage = (props) => {
  let history = useHistory();
  const [hasDoterraAccount, setHasDoterraAccount] = useState("no");
  const [submitAttempted, setSubmitAttempted] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [value, setValue] = useState({
    email: "",
    firstName: "",
    lastName: "",
    phoneNumber: "",
    password: "",
    confirm_password: "",
    // Doterra fields
    doterraFullName: "",
    doterraId: "",
    doterraEmail: "",
    doterraPhone: "",
    mentorFullName: "",
    mentorDoterraId: "",
    // Checkboxes
    confirmNoMentor: false,
    acceptTerms: false,
  });

  // Auto-fill doTERRA fields when personal info changes
  const handlePersonalInfoChange = (e) => {
    const { name, value: inputValue, type, checked } = e.target;
    const newValue = { 
      ...value, 
      [name]: type === 'checkbox' ? checked : inputValue 
    };
    
    // Auto-fill doTERRA fields if hasDoterraAccount is "yes"
    if (hasDoterraAccount === "yes") {
      if (name === "firstName" || name === "lastName") {
        newValue.doterraFullName = `${newValue.firstName} ${newValue.lastName}`.trim();
      } else if (name === "email") {
        newValue.doterraEmail = inputValue;
      } else if (name === "phoneNumber") {
        newValue.doterraPhone = inputValue;
      }
    }
    
    setValue(newValue);
  };

  // Regular change handler for non-personal info fields
  const changeHandler = (e) => {
    const { name, value: inputValue, type, checked } = e.target;
    setValue({ 
      ...value, 
      [name]: type === 'checkbox' ? checked : inputValue 
    });
  };

  const handleDoterraAccountChange = (e) => {
    setHasDoterraAccount(e.target.value);
    // Reset doterra specific fields when switching
    setValue({
      ...value,
      doterraFullName: "",
      doterraId: "",
      doterraEmail: "",
      doterraPhone: "",
      mentorFullName: "",
      mentorDoterraId: "",
      confirmNoMentor: false,
    });
  };

  const submitForm = async (e) => {
    e.preventDefault();
    setSubmitAttempted(true);
    
    // Validate required fields
    const requiredFields = ['firstName', 'lastName', 'email', 'password', 'confirm_password'];
    const hasEmptyFields = requiredFields.some(field => !value[field]);
    const isEmailValid = /\S+@\S+\.\S+/.test(value.email);
    const doPasswordsMatch = value.password === value.confirm_password;
    
    // Check for missing basic fields first
    if (hasEmptyFields) {
      const missingFields = requiredFields.filter(field => !value[field]);
      toast.error(`Următoarele câmpuri sunt obligatorii: ${missingFields.map(field => {
        switch(field) {
          case 'firstName': return 'Prenume';
          case 'lastName': return 'Nume';
          case 'email': return 'Email';
          case 'password': return 'Parolă';
          case 'confirm_password': return 'Confirmare parolă';
          default: return field;
        }
      }).join(', ')}`);
      return;
    }
    
    if (!isEmailValid) {
      toast.error("Te rugăm să introduci un email valid.");
      return;
    }
    
    if (!doPasswordsMatch) {
      toast.error("Parolele nu se potrivesc.");
      return;
    }
    
    // Validate doTERRA fields if user has account
    let hasEmptyDoterraFields = false;
    if (hasDoterraAccount === "yes") {
      const doterraRequiredFields = ['doterraFullName', 'doterraId', 'doterraEmail', 'doterraPhone', 'mentorFullName', 'mentorDoterraId'];
      hasEmptyDoterraFields = doterraRequiredFields.some(field => !value[field]);
      const isDoterraEmailValid = /\S+@\S+\.\S+/.test(value.doterraEmail);
      
      if (hasEmptyDoterraFields) {
        const missingDoterraFields = doterraRequiredFields.filter(field => !value[field]);
        toast.error(`Următoarele câmpuri doTERRA sunt obligatorii: ${missingDoterraFields.map(field => {
          switch(field) {
            case 'doterraFullName': return 'Nume complet doTERRA';
            case 'doterraId': return 'ID doTERRA';
            case 'doterraEmail': return 'Email doTERRA';
            case 'doterraPhone': return 'Telefon doTERRA';
            case 'mentorFullName': return 'Nume mentor';
            case 'mentorDoterraId': return 'ID mentor doTERRA';
            default: return field;
          }
        }).join(', ')}`);
        return;
      }
      
      if (!isDoterraEmailValid) {
        toast.error("Te rugăm să introduci un email doTERRA valid.");
        return;
      }
    }
    
    // Validate required checkboxes - ALWAYS check these regardless of state
    if (hasDoterraAccount === "no") {
      if (!value.confirmNoMentor) {
        toast.error("Te rugăm să confirmi că nu ai alt îndrumător.");
        return;
      }
    }
    
    // Terms acceptance is ALWAYS required regardless of doTERRA account status
    if (!value.acceptTerms) {
      toast.error("Te rugăm să accepți termenii și condițiile.");
      return;
    }

      try {
        // Create user with Firebase Auth
        const userCredential = await auth.createUserWithEmailAndPassword(value.email, value.password);
        
        // Prepare user data for database (without passwords)
        const userData = {
          email: value.email,
          firstName: value.firstName,
          lastName: value.lastName,
          phoneNumber: value.phoneNumber,
          doterraFullName: value.doterraFullName,
          doterraId: value.doterraId,
          doterraEmail: value.doterraEmail,
          doterraPhone: value.doterraPhone,
          mentorFullName: value.mentorFullName,
          mentorDoterraId: value.mentorDoterraId,
          confirmNoMentor: value.confirmNoMentor,
          acceptTerms: value.acceptTerms,
          hasDoterraAccount: hasDoterraAccount,
          firebaseUid: userCredential.user.uid
        };

        // Save user data to database
        await userService.createUser(userData);
        
        // Auto-login: Update Redux store with user data
        props.addUser({
          ...userCredential.user,
          ...userData
        });
        
        // toast.success("Înregistrarea a fost finalizată cu succes! Bine ai venit!");
        
        // Check for special mentor ID and set permissions
        if (value.mentorDoterraId === "13634849") {
          toast.info("Ai primit acces special la librăria completă!");
          // Here you would set special permissions
        }
        
        // Redirect to home page with auto-login
        history.push("/home");
        
      } catch (error) {
        console.error("Error during registration:", error);
        toast.error(error.message || "Eroare la înregistrare. Te rugăm să încerci din nou.");
      }
  };

  return (
    <Fragment>
      <NewNavbar/>
      <NewOverrides/>
      <NewDesignSystem/>

      <NewPageHeader />
      <div className="signup-wrapper">
        <div className="signup-container">
          <div className="signup-glass-card">
            <div className="signup-header">
              <h2>Înregistrare</h2>
            <p>Alătură-te comunității noastre</p>
          </div>

          <form onSubmit={submitForm} className="signup-form">
            {/* Doterra Account Question */}
            <div className="form-section">
              <FormControl component="fieldset" className="doterra-question">
                <FormLabel component="legend" className="question-label">
                  Ai cont doTERRA?
                </FormLabel>
                <RadioGroup
                  value={hasDoterraAccount}
                  onChange={handleDoterraAccountChange}
                  row
                >
                  <FormControlLabel 
                    value="no" 
                    control={<Radio color="primary" />} 
                    label="❌ NU" 
                  />
                  <FormControlLabel 
                    value="yes" 
                    control={<Radio color="primary" />} 
                    label="✅ DA" 
                  />
                </RadioGroup>
              </FormControl>
            </div>

            {/* Basic Information */}
            <div className="form-section">
              <Typography variant="h6" className="section-title">
                Informații personale
              </Typography>
              
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    name="firstName"
                    label="Nume"
                    value={value.firstName}
                    onChange={handlePersonalInfoChange}
                    className="glass-input"
                    error={submitAttempted && !value.firstName}
                    helperText={submitAttempted && !value.firstName ? "Acest câmp este obligatoriu" : ""}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    name="lastName"
                    label="Prenume"
                    value={value.lastName}
                    onChange={handlePersonalInfoChange}
                    className="glass-input"
                    error={submitAttempted && !value.lastName}
                    helperText={submitAttempted && !value.lastName ? "Acest câmp este obligatoriu" : ""}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    name="email"
                    label="Adresa de email"
                    type="email"
                    value={value.email}
                    onChange={handlePersonalInfoChange}
                    className="glass-input"
                    error={submitAttempted && (!value.email || !/\S+@\S+\.\S+/.test(value.email))}
                    helperText={submitAttempted && !value.email 
                      ? "Acest câmp este obligatoriu" 
                      : submitAttempted && !/\S+@\S+\.\S+/.test(value.email) 
                        ? "Te rugăm să introduci un email valid" 
                        : ""}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    name="phoneNumber"
                    label="Numărul de telefon"
                    value={value.phoneNumber}
                    onChange={handlePersonalInfoChange}
                    className="glass-input optional-field"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    name="password"
                    label="Parola"
                    type="password"
                    value={value.password}
                    onChange={changeHandler}
                    className="glass-input"
                    error={submitAttempted && !value.password}
                    helperText={submitAttempted && !value.password ? "Acest câmp este obligatoriu" : ""}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    name="confirm_password"
                    label="Confirmă parola"
                    type="password"
                    value={value.confirm_password}
                    onChange={changeHandler}
                    className="glass-input"
                    error={submitAttempted && (!value.confirm_password || value.password !== value.confirm_password)}
                    helperText={submitAttempted && !value.confirm_password 
                      ? "Acest câmp este obligatoriu" 
                      : submitAttempted && value.password !== value.confirm_password 
                        ? "Parola nu se potrivește" 
                        : ""}
                  />
                </Grid>
              </Grid>
            </div>

            {/* Conditional Doterra Information */}
            {hasDoterraAccount === "no" ? (
              <div className="form-section no-doterra-section">
                <div className="checkboxes-container">
                  <div className="checkbox-item">
                    <input
                      type="checkbox"
                      id="confirmNoMentor"
                      name="confirmNoMentor"
                      checked={value.confirmNoMentor}
                      onChange={changeHandler}
                      required
                      className="hidden-checkbox"
                    />
                    <label 
                      htmlFor="confirmNoMentor" 
                      className={`checkbox-label ${value.confirmNoMentor ? 'checked' : ''}`}
                    >
                      Confirm că nu am alt îndrumător 
                    </label>
                    {submitAttempted && !value.confirmNoMentor && (
                      <div className="errorMessage">Acest câmp este obligatoriu</div>
                    )}
                  </div>
                  
                  <div className="checkbox-item">
                    <input
                      type="checkbox"
                      id="acceptTerms"
                      name="acceptTerms"
                      checked={value.acceptTerms}
                      onChange={changeHandler}
                      required
                      className="hidden-checkbox"
                    />
                    <label 
                      htmlFor="acceptTerms" 
                      className={`checkbox-label ${value.acceptTerms ? 'checked' : ''}`}
                    >
                      Accept{" "}
                      <Link 
                        to="/terms" 
                        target="_blank" 
                        className="terms-link"
                        onClick={(e) => e.stopPropagation()}
                      >
                        Termenii și Condițiile
                      </Link>{" "}
                      *
                    </label>
                    {submitAttempted && !value.acceptTerms && (
                      <div className="errorMessage">Acest câmp este obligatoriu</div>
                    )}
                  </div>
                </div>
              </div>
            ) : (
              <div className="form-section doterra-section">
                <Typography variant="h6" className="section-title">
                  Informații cont doTERRA
                </Typography>
                
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      name="doterraFullName"
                      label="Nume Prenume aferent contului doTERRA"
                      value={value.doterraFullName}
                      onChange={changeHandler}
                      className="glass-input"
                      error={submitAttempted && !value.doterraFullName}
                      helperText={submitAttempted && !value.doterraFullName ? "Acest câmp este obligatoriu" : ""}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      name="doterraId"
                      label="ID doTERRA PERSONAL"
                      value={value.doterraId}
                      onChange={changeHandler}
                      className="glass-input"
                      error={submitAttempted && !value.doterraId}
                      helperText={submitAttempted && !value.doterraId ? "Acest câmp este obligatoriu" : ""}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      name="doterraEmail"
                      label="Adresa de email aferentă contului"
                      type="email"
                      value={value.doterraEmail}
                      onChange={changeHandler}
                      className="glass-input"
                      error={submitAttempted && (!value.doterraEmail || !/\S+@\S+\.\S+/.test(value.doterraEmail))}
                      helperText={submitAttempted && !value.doterraEmail 
                        ? "Acest câmp este obligatoriu" 
                        : submitAttempted && !/\S+@\S+\.\S+/.test(value.doterraEmail) 
                          ? "Te rugăm să introduci un email valid" 
                          : ""}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      name="doterraPhone"
                      label="Numărul de telefon"
                      value={value.doterraPhone}
                      onChange={changeHandler}
                      className="glass-input"
                      error={submitAttempted && !value.doterraPhone}
                      helperText={submitAttempted && !value.doterraPhone ? "Acest câmp este obligatoriu" : ""}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      name="mentorFullName"
                      label="Nume Prenume ÎNDRUMĂTOR"
                      value={value.mentorFullName}
                      onChange={changeHandler}
                      className="glass-input"
                      error={submitAttempted && !value.mentorFullName}
                      helperText={submitAttempted && !value.mentorFullName ? "Acest câmp este obligatoriu" : ""}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      name="mentorDoterraId"
                      label="ID doTERRA ÎNDRUMĂTOR"
                      value={value.mentorDoterraId}
                      onChange={changeHandler}
                      className="glass-input"
                      error={submitAttempted && !value.mentorDoterraId}
                      helperText={submitAttempted && !value.mentorDoterraId ? "Acest câmp este obligatoriu" : ""}
                    />
                  </Grid>
                </Grid>

                <div className="info-messages">
                  <div className="info-message warning">
                    ❗ Dacă ai îndrumător direct @Ariana Popa vei primi acces garantat la librăria echipei
                  </div>
                  <div className="info-message info">
                    ❗ Dacă ești membru înscris la un îndrumător care aparține echipei @Ariana Popa, vei primi acces garantat după verificare
                  </div>
                  <div className="info-message alert">
                    ‼️ Dacă ești membru înscris în altă echipă în afara grupului Arianei nu vei primi acces la librăria extinsă, ci doar la o parte din conținut
                  </div>
                </div>

                <div className="accept-terms-container">
                  <input
                    type="checkbox"
                    id="acceptTermsWithAccount"
                    name="acceptTerms"
                    checked={value.acceptTerms}
                    onChange={changeHandler}
                    required
                    className="hidden-checkbox"
                  />
                  <label 
                    htmlFor="acceptTermsWithAccount" 
                    className={`checkbox-label ${value.acceptTerms ? 'checked' : ''}`}
                  >
                    Accept{" "}
                    <Link 
                      to="/terms" 
                      target="_blank" 
                      className="terms-link"
                      onClick={(e) => e.stopPropagation()}
                    >
                      Termenii și Condițiile
                    </Link>{" "}
                    *
                  </label>
                  {submitAttempted && !value.acceptTerms && (
                    <div className="errorMessage">Acest câmp este obligatoriu</div>
                  )}
                </div>
              </div>
            )}

            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '32px' }}>
              <Button
                type="submit"
                className="submit-btn glass-morphism-btn"
                size="large"
                style={{ minWidth: '250px', maxWidth: '350px' }}
              >
                <span className="btn-text">Înregistrare</span>
                <div className="btn-gradient"></div>
              </Button>
            </div>

            <div className="form-footer">
              <p>
                Ai deja un cont?{" "}
                <Link to="/login" className="login-link">
                  Întoarce-te la pagina de logare
                </Link>
              </p>
            </div>
          </form>
          
          <div className="back-to-home">
            <Link to="/" className="back-to-home-btn">
              Înapoi la Pagina Principală
            </Link>
          </div>
        </div>
      </div>
    </div>
      <NewBackButton/>
      <NewFooter/>
      <NewMadeWith/>
      <NewScrollTop/>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

export default withRouter(connect(mapStateToProps, { addUser })(SignUpPage));
